import React from 'react';
import i18n from 'i18n-react';

import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';

const MobileWarning = () => (
  <div>
    <div className="container__mobileButtons">
      <section>{i18n.translate('onMobile.body')}</section>
      <h5>{i18n.translate('onMobile.benefits.header')}</h5>
      <ul>
        <li>{i18n.translate('onMobile.benefits.1')}</li>
        <li>{i18n.translate('onMobile.benefits.2')}</li>
        <li>{i18n.translate('onMobile.benefits.3')}</li>
      </ul>
      <div className="buttons">
        <img src={apple} alt="App store" />
        <img src={google} alt="Google Play" />
      </div>
    </div>
  </div>
);

export default MobileWarning;
